/**
 *
 * Todo
 *
 * Display top level stats like:
 *
 *  - Total number of suggestions (medium or small )
 *  - Total number of prices (small)
 *  - Best  price across all suggestions (Big)
 *  -
 *
 *  - Total VE accepted(?)
 *
 *
 *  todo - developer and builder Widgets can be broken out...
 * */
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";

import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BuilderVESummary, DeveloperVESummary } from "../ve/ve_model";
import { moneyFormatter } from "../../lib/formatters";

type BuilderWidgetProps = {
    ve_summary: BuilderVESummary;
};

function VEWidgetHeader() {
    const navigate = useNavigate();
    const { project_id } = useParams<string>();
    return (
        <CardHeader>
            <CardTitle>
                <div className="flex justify-between items-center">
                    <div>VE Summary</div>
                    <Button
                        variant="outline"
                        onClick={() => navigate(`/project/${project_id}/ve`)}
                    >
                        Go to VE
                    </Button>
                </div>
            </CardTitle>
        </CardHeader>
    );
}

export function BuilderVEWidget({ ve_summary }: BuilderWidgetProps) {
    return (
        <Card>
            <VEWidgetHeader />
            <CardContent className="h-64">
                <div className="columns-2 ">
                    <p>VE Items Suggested</p>
                    <p className="text-2xl">{ve_summary.num_suggestions}</p>
                </div>
                <br />
                <div className="columns-2">
                    Total VE
                    <p className="text-2xl">{ve_summary.num_priced}</p>
                </div>
                <br />
                <div className="columns-2">
                    Total Potential Savings ($)
                    <p className="text-xl">
                        {moneyFormatter.format(
                            ve_summary.best_savings_potential
                        )}
                    </p>
                </div>
                <br />
                <div className="columns-2">
                    Suggestions awaiting Input
                    <p className="text-xl">
                        {ve_summary.items_awaiting_pricing}
                    </p>
                </div>
            </CardContent>
        </Card>
    );
}

type DeveloperWidgetProps = {
    ve_summary: DeveloperVESummary;
};

export function DeveloperVEWidget({ ve_summary }: DeveloperWidgetProps) {
    if(!ve_summary){
        return <Card><VEWidgetHeader /><CardContent>No Suggestions</CardContent></Card>
    }
    return (
        <Card>
            <VEWidgetHeader />
            <CardContent className="h-64">
                <div className="columns-2 ">
                    <p>VE Items Suggested</p>
                    <p className="text-2xl">{ve_summary.num_suggestions}</p>
                </div>
                <br />
                <div className="columns-2">
                    Total VE
                    <p className="text-2xl">{ve_summary.num_priced}</p>
                </div>
                <br />
                <div className="columns-2">
                    Total Potential Savings ($)
                    <p className="text-xl">
                        {moneyFormatter.format(
                            ve_summary.best_savings_potential
                        )}
                    </p>
                </div>
                <br />
                <div className="columns-2">
                    Total VE suggested ($)
                    <p className="text-xl">
                        {moneyFormatter.format(
                            ve_summary.total_savings_suggested
                        )}
                    </p>
                </div>
            </CardContent>
        </Card>
    );
}
